// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"d5616eba","845":"d0f58b9e"}[chunkId] + ".chunk.js";
};